export default "__VITE_ASSET__DiuVAhNQ__"